import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Configure tailwind-merge to recognize custom typography classes
// This prevents text-heading-xl from being removed when combined with text-foreground
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'heading-xl', 'heading-lg', 'heading-md', 'heading-sm', 'heading-xs', 'heading-xxs',
            'display-hero', 'display-3xl', 'display-2xl', 'display-xl', 'display-lg', 'display-md', 'display-sm',
            'hero-xs', 'hero-sm', 'hero-md', 'hero-lg', 'hero-xl', 'hero-2xl',
            'body-lg', 'body-md', 'body-sm',
            'ui-md', 'ui-sm',
            'caption-md', 'caption-sm', 'caption-xs',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs))
}
